// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2EGjQ","select":"Header_select__3sS_o","clinic":"Header_clinic__118RX"};